module.exports = __webpack_public_path__ + "static/media/entity-quickstart_bundle-reorder.e796b7c9.png";